const s = {
  name: "InsightsEngagement",
  dimensions: { width: 40, height: 38 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 38" style="enable-background:new 0 0 40 38;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M12.5,5.5C10.6,5.5,9,7.1,9,9c0,1.9,1.6,3.5,3.5,3.5S16,10.9,16,9C16,7.1,14.4,5.5,12.5,5.5z M11,9
			c0-0.8,0.7-1.5,1.5-1.5S14,8.2,14,9c0,0.8-0.7,1.5-1.5,1.5S11,9.8,11,9z"/>
		<path class="st0" d="M8,17c0-0.5,0.5-1,1-1h7c0.5,0,1,0.5,1,1v7h2v-7c0-1.7-1.3-3-3-3H9c-1.7,0-3,1.3-3,3v7h2V17z"/>
		<path class="st0" d="M21,32h13v-2H21V32z"/>
		<path class="st0" d="M34,28H21v-2h13V28z"/>
		<path class="st0" d="M6,30v2h13v-2H6z"/>
		<path class="st0" d="M6,28v-2h13v2H6z"/>
		<path class="st0" d="M21,24h13v-2H21V24z"/>
		<path class="st0" d="M34,20H21v-2h13V20z"/>
		<path class="st0" d="M21,16h13v-2H21V16z"/>
		<path class="st0" d="M34,12H21v-2h13V12z"/>
		<path class="st0" d="M21,8h13V6H21V8z"/>
		<path class="st0" d="M0,5c0-2.8,2.2-5,5-5h30c2.8,0,5,2.2,5,5v28c0,2.8-2.2,5-5,5H5c-2.8,0-5-2.2-5-5V5z M5,2C3.3,2,2,3.3,2,5v28
			c0,1.7,1.3,3,3,3h30c1.7,0,3-1.3,3-3V5c0-1.7-1.3-3-3-3H5z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as InsightsEngagement
};
